// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/batamp/" + chunkId + "." + {"251":"22a0cdbaead3293ade78","311":"a831a923a50fc0d780cc","574":"13a160b05884d51ad5ee","608":"045752d0e3f2226597be","752":"e4a16e3fff3f13f108f2","765":"6b2959163df31bd81b1e","766":"4e80d5a3c57d151ef9f5"}[chunkId] + ".js";
};